import { BeneficiaryIntensityDto } from '../../dto/beneficiary-intensity.dto';
import { ReferentDto } from '../../dto/referent.dto';
import { SupportDto } from '../../dto/supportDto';

export class BeneficiaryComplement {
  constructor(
    public id: number,
    public childrenCount: number,
    public dependentsNumber: number,
    public rsaRightBeginDate: Date,
    public currentReferent: ReferentDto,
    public reasonOrientationEnding: string,
    public healthInsuranceId?: number,
    public supportHistories?: SupportDto[],
    public intensity?: BeneficiaryIntensityDto,
    public singleParent?: boolean,
  ) {}

  public static fromJson(json: any): BeneficiaryComplement {
    return new BeneficiaryComplement(
      json.id,
      json.childrenCount,
      json.dependentsNumber,
      json.rsaRightBeginDate ? new Date(json.rsaRightBeginDate) : undefined,
      ReferentDto.fromJson(json.currentReferent),
      json.reasonOrientationEnding,
      json.healthInsuranceId,
      json.supportHistories,
      BeneficiaryIntensityDto.fromJson(json.intensity),
      json.singleParent,
    );
  }
}
